import Manage from "./Manage";
import ManageBody from "./ManageBody";
import ManageFooter from "./ManageFooter";

Manage.Body = ManageBody;
Manage.Footer = ManageFooter;

export default Manage;
